export default {"src":"/_next/static/media/landscape_article.67576f28.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};